import Chatbot from "@src/views/Chatbot";
import type { NextPage } from "next/types";

const ChatbotPage: NextPage = () => <Chatbot />;

export default ChatbotPage;
